import AxiosService from "./axiosServices";

// const axiosService = new AxiosService();

const GenealogyService = {
  fetchGenealogyReports: (requestData) => {
    return AxiosService.Get("api/cam/pc/list-genealogy-reports/", {
      params: requestData,
    });
  },

  fetchProducedProducts: (requestData) => {
    return AxiosService.Get("api/cam/srm/genealogy-list/", {
      params: requestData,
    });
  },

  fetchManufacturingSites: (requestData) => {
    return AxiosService.Get("api/cam/srm/genealogy-list/", {
      params: requestData,
    });
  },

  fetchUnitOperations: (requestData) => {
    return AxiosService.Get("api/cam/srm/genealogy-list/", {
      params: requestData,
    });
  },

  fetchProductDescription: (requestData) => {
    const { product, site, unitOfOperation } = requestData;

    const productId = product?.id || "";
    const siteId = site?.id || "";

    // convert array → comma separated string
    const uopIds = (unitOfOperation || []).join(",");

    const url = `api/cam/pc/get-description-genealogy/${productId}/${siteId}/${uopIds}/`;

    return AxiosService.Get(url);
  },

  fetchParameters: (requestData) => {
    const productId = requestData.product_id?.id;
    const siteId = requestData.site_id?.id;

    // assuming only 1 unit operation (take first)
    const unitOpIds = requestData.unit_operation_id?.map((u) => u.id).join(",");

    return AxiosService.Get(
      `api/cam/pc/get-parameters-genealogy/${productId}/${siteId}/${unitOpIds}/`,
    );
  },

  generateGenealogyReport: (requestData) => {
    return AxiosService.Post(
      "api/cam/pc/get-genealogy-report-data/",
      requestData,
    );
  },

  fetchComponents: (requestData) => {
    const payload = {
      batch_number: Array.isArray(requestData) ? requestData : [],
    };

    return AxiosService.Post("api/cam/pc/get-components-genealogy/", payload);
  },

  // fetchGenealogySingleReport: (requestData) => {
  //   return AxiosService.Get("api/cam/srm/genealogy-list/", {
  //     params: requestData,
  //   });
  // },

  fetchFilteredBatchList: (payload) => {
    return AxiosService.Get(`api/cam/pc/get-batches-genealogy/`, {
      params: {
        uop_ids: payload.unitOfOperation.map((item) => item.id).join(","),
        start_date: payload.start_date,
        end_date: payload.end_date,
      },
    }).then((res) => res.data);
  },

  saveGenealogyReport: (requestData) => {
    return AxiosService.Post(
      "api/cam/pc/create-genealogy-report/",
      requestData,
    );
  },

  fetchGenealogyReportById: (id) => {
    return AxiosService.Get(`api/cam/pc/get-genealogy-report/${id}/`);
  },
};

export default GenealogyService;
